import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";

//component
import LayoutHeader from "../00_Nav/layout/layout_header";
import TriggerInit from "./trigger/trigger_init";
import BailiffUpload from "./component/bailiff_upload";
import BailiffListing from "./component/bailiff_listing";
//action
import { setHighlight } from "../../store/bailiff/nav/nav.action";

import "./style.css";
import DialogPaymentQR from "./dialog/dialog_payment_qr";
import BailiffJob from "./component/bailiff_job";
import DialogPaymentJob from "./dialog/dialog_payment_job";
import DialogPaymentConfirm from "./dialog/dialog_payment_confirm";
import DialogBailiffPreview from "./dialog/dialog_bailiff_preview";
import DialogPaymentUpload from "./dialog/dialog_payment_upload";
import BailiffHacker from "./component/bailiff_hacker";
// import DialogAccountInfo from "./dialog/dialog_account_info";

const { Content } = Layout;

const BailiffScreen = () => {
  // -------------------------- VAR --------------------------
  const title = "Đăng tải file Audio/Video";

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row gutter={[0, 24]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BailiffHacker />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BailiffUpload />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BailiffJob />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BailiffListing />
          </Col>
        </Row>
        <DialogPaymentConfirm />
        <DialogPaymentJob />
        <DialogPaymentQR />
        <DialogPaymentUpload />
        <DialogBailiffPreview />
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default BailiffScreen;
